export const RESPONSE_STATUS  = {
    INTERNAL_SERVER_ERROR : "T500",
    INVALID_PARAMETER_EXCEPTION : "T600",
    INVALID_WEIVER_CODE_EXCEPTION : "W401",
    VALID_RESPONSE : "T200",
    INVALID_JWT_EXCEPTION : "T700"
};



// WEBPACK FOOTER //
// ./src/app/common/constant/ResponseStatus.ts